import { ScaleAndLocationDialogService } from './../scale-and-location-dialog/scale-and-location-dialog-service';
import { SLMap } from 'src/app/model/sl-map';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { LegendClassComponent } from './../../legend-view/legend-item/legend-class/legend-class.component';
import { LegendViewComponent } from './../../legend-view/legend-view.component';
import { InterruptableTimer } from './../../../model/interruptabletimer';
import { QRCodeComponent } from 'angularx-qrcode';
import { EnvService } from './../../../env.service';
import { MediaService } from './../../../model/api-services/media.service';
import { DateQualifierService } from 'src/app/model/api-services/qualifiers/date-qualifier.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NumberQualifierService } from 'src/app/model/api-services/qualifiers/number-qualifier.service';
import { AppContext } from 'src/app/types/app-context';
import { SLContext } from 'src/app/types/sl-context';
import { PdfExportService } from './../../../services/pdf-export.service';
import { PDFOutputPreviewDialogService } from './pdf-output-preview-dialog-service';
import { SubScriptionMgr } from 'src/app/model/SubscriptionMgr';
import { Component, OnInit, OnDestroy, HostBinding, ViewChild, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef } from '@angular/core';
import { NgbModalRef, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import dragula from 'dragula';
import html2canvas from 'html2canvas';
import { GeoLocationQualifierService } from 'src/app/model/api-services/qualifiers/geo-location-qualifier-service';
import { url } from 'inspector';
import { TreeNode } from '@circlon/angular-tree-component';
import { FieldAlreadyExistsError } from 'pdf-lib';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';

export type NotesStyle = 'index' | 'light-rule' | 'dot-grid' | 'grid';
;
@Component({
  selector: 'app-pdf-output-preview-dialog',
  templateUrl: './pdf-output-preview-dialog.component.html',
  styleUrls: ['./pdf-output-preview-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PDFOutputPreviewDialogComponent implements OnInit {



  private _useSpecial: boolean = false;
  @HostBinding('class.use-special')
  set useSpecial(used: boolean) {
    this._useSpecial = used;
    this.map.component.ToggleReticleExtra(this._useSpecial);
    this.Refresh();
  }
  get useSpecial(): boolean {
    return this._useSpecial;
  }
  private _pdfWidth: string = '0px';

  private _minimized = false;
  public set minimized(val: boolean) {
    const oldVal = this._minimized;
    this._minimized = val;
    if (this._modalElement) {
      this._modalElement.classList.toggle('minimized', val);
    }
    this.map.component.ToggleReticle(val);
    if (!!oldVal && !this.minimized) {
      this.Capture();
    }
    this.Refresh();
  }
  public get minimized(): boolean {
    return this._minimized;
  }

  public get noteRowsH(): Array<string> {
    const max = (8 * PdfExportService.ScreenUnitPerInch) / (.25 * PdfExportService.ScreenUnitPerInch);
    const rows = [];
    for (let i = 0; i <= max; i++) {
      rows.push('&nbps;');
    }
    return rows;
  }
  public noteRows = ['&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;', '&nbsp;'];

  private _includeRocketBook = false;
  set includeRocketBook(included: boolean) {
    this._includeRocketBook = included;
    this.Refresh();
  }
  get includeRocketBook(): boolean {
    return this._includeRocketBook;
  }

  private _includeLogo = true;
  public set includeLogo(included: boolean) {
    this._includeLogo = included;
    this.Refresh();
  }
  public get includeLogo(): boolean {
    return this._includeLogo;
  }

  private _logoHeight: string = '';
  public set logoHeight(height: string) {
    this._logoHeight = height;
    const styleHeight = (height === '') ? '' : height + 'in';
    this.domNode.nativeElement.style.setProperty('--logo-height', styleHeight);
    this.Refresh();
  }
  public get logoHeight(): string {
    return this._logoHeight;
  }

  private _includeNotes = false;
  public set includeNotes(included: boolean) {
    const prevVal = this._includeNotes;
    this._includeNotes = included;
    this.UpdateSpecial();

    // this.Refresh();
  }
  public get includeNotes(): boolean {
    return this._includeNotes;
  }

  private _notesStyle: NotesStyle = 'index';
  public set notesStyle(style: NotesStyle) {
    this._notesStyle = style;
  }
  public get notesStyle(): NotesStyle {
    return this._notesStyle;
  }
  private _includeLegend = false;
  public set includeLegend(included: boolean) {
    this._includeLegend = included;
    this.UpdateSpecial();
    // this.Refresh();
  }
  public get includeLegend(): boolean {
    return this._includeLegend;
  }

  get minimizeTitle(): string {
    return !!this.minimized ? 'Return to PDF Export view' : 'Collapse PDF Export view to adjust map settings';

  }
  public get legendItems(): Array<any> {
    const legendGroups = [];
    if (!this.legendInfo?.legend) return [];
    if (!this.legendInfo?.legend) return [];
    for (const id in this.legendInfo.legend) {
      if (this.legendInfo.legend.hasOwnProperty(id) === false) continue;
      const item = this.legendInfo.legend[id];
      if (!!item.children) {
        for (const subId in item.children) {
          if (!item.children.hasOwnProperty(subId)) continue;
          const sub = item.children[subId];
          sub.parent = item;
          legendGroups.push(sub);
        }
      } else {
        legendGroups.push(item);
      }
    }
    return legendGroups;
  }
  GetLegendLabel(node: any): string {
    if (!!node.parent && node.parent.name !== '') {
      return node.parent.name + ' : ' + node.name + ((!!node.layer.description && node.layer.description.trim() !== '') ? ' - ' + node.layer.description + '' : '');
    }
    return node.name;
  }
  get editorConfig(): any {
    return {
      toolbarCanCollapse: true,
      toolbarStartupExpanded: false,
      allowedContent: true,
      removeFormatAttributes: '',
      extraPlugins: 'sourcearea',
      toolbarGroups: [
        // { name: 'clipboard',   groups: [ 'clipboard', 'undo' ] },
        { name: 'mode' },//, 'document', 'doctools' ] },
        { name: 'editing', groups: ['source'] },
        { name: 'links' },
        //{ name: 'insert' },
        //{ name: 'forms' },
        // { name: 'tools' },
        //{ name: 'others' },
        '/',
        { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
        { name: 'paragraph', groups: ['list', 'indent', 'align'] },
        { name: 'styles' },
        { name: 'colors' },
        // { name: 'about' }
      ]
    }
  }
  private _description: string = '';
  set description(desc: string) {
    this._description = desc;
    this.cdr.markForCheck();
    this.Refresh();

  }
  get description(): string {
    return this._description;
  }
  get safeDescription(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this._description);
  }

  get map(): SLMap | undefined {
    return this.context?.map;
  }

  private _disclaimer: string = 'The information provided here is for <em>reference purposes only</em> from the latest data made available for online consumption at the time of printing on %date%. Neither completeness nor accuracy are guaranteed. It is recommended that complete and up-to-date information be saught to corroborate what is available here.  Conclusions drawn from information herein are solely the user\'s responsibility.';
  set disclaimer(disc: string) {
    this._disclaimer = disc;
    this.Refresh();
    this.previewTimer.Interrupt(true);

  }
  get disclaimer(): string {
    return this._disclaimer;
    return
  }
  get safeDisclaimer(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(
      this._disclaimer.replace('%date%',
        DateQualifierService.ToString(new Date(), 'date#March 04, 2345'))
    );
  }
  set pdfWidth(width: string) {
    this._pdfWidth = width;
    this.Refresh();
  }
  get pdfWidth(): string {
    return this._pdfWidth;
  }
  get width(): number {
    return Number(this._pdfWidth.replace('px', ''));
  }

  private _pdfHeight: string = '0px';
  set pdfHeight(height: string) {
    this._pdfHeight = height;
    this.Refresh();
  }
  get pdfHeight(): string {
    return this._pdfHeight;
  }

  get height(): number {
    return Number(this._pdfHeight.replace('px', ''));
  }
  private _previewContainerBuffer = '.25rem';
  get minPageHeight(): string {
    if (this.orientation === 'landscape') {
      return `calc(${this.pdfHeight} + ${this._previewContainerBuffer})`;
    }
    return `calc(${this.pdfWidth} + ${this._previewContainerBuffer})`;

  }
  get maxPageHeight(): string {
    if (this.orientation === 'landscape') {
      return `calc(${this.pdfWidth} + ${this._previewContainerBuffer})`;
    }
    return `calc(${this.pdfHeight} + ${this._previewContainerBuffer})`;
  }
  get minDim(): string {
    return Math.min(this.width, this.height) + 'px';
  }
  get angle(): string {
    if (!this.context?.map?.ui) return '';
    const rotation = -this.context.map.ui.getBearing();
    return `${rotation}deg`;
  }
  private _orientation: string = 'landscape';
  public set orientation(orient: string) {
    this._orientation = orient;
    this.pageContainer.nativeElement.style.setProperty('--container-height', this.minPageHeight);
    this.pageContainer.nativeElement.style.setProperty('--container-width', this.maxPageHeight);
    this.Refresh();
    //this.Capture();
  }
  public get orientation(): string {
    return this._orientation
  }
  private _image = '';
  public get image(): string {
    return this._image
  }
  private _imgHeight: number = 0;
  get imgHeight(): string {
    return this._imgHeight + 'px';

  }
  private _imgWidth: number = 0;
  get imgWidth(): string {
    return this._imgWidth + 'px';

  }
  public get preview(): string {
    if (!this._buffer) return '';
    return this._buffer.toDataURL();
  }
  private _title?: string = '';
  public get title(): string {
    if (!this._title) {
      if (this.context) {
        const title = this.context.map?.project?.name;
        if (!title) return '';
        this._title = title;
      }
    }
    return this._title;
  }
  public set title(t: string) {
    this._title = t;


  }
  public get safeTitle(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(this.title);
  }
  public get location(): string {
    if (!this.context?.map?.ui) return '';
    const center = this.context.map?.ui.getCenter();
    const lng = center.lng;
    const lat = center.lat;
    let loc = GeoLocationQualifierService.ToDegMinSec(lng, 4) + 'N';
    loc += '<BR>' + GeoLocationQualifierService.ToDegMinSec(lat, 4) + 'E';
    //loc += ' <BR>Web Map Zoom: ' + NumberQualifierService.ToString(this.context.map.ui.getZoom(),'comma-dot',2);

    return loc;

  }
  private _orgLogo: string = '';
  get orgLogo() {
    if (!this.includeLogo) return '';
    return this._orgLogo;
  }

  private _url = '';
  get qrString(): string {
    if (this._url === '') {
      this._url = this.envSvc.GetAppURL();

      // this._url = 'https://localhost:4200/public/sl-viewer/'+this.context.map.project.id;
    }
    const center = this.context.map.ui.getCenter();
    const lng = Number(center.lng).toFixed(4);
    const lat = Number(center.lat).toFixed(4);
    const zoom = this.context.map.ui.getZoom().toFixed(2);
    const pitch = this.context.map.ui.getPitch().toFixed(2);
    const bearing = this.context.map.ui.getBearing().toFixed(2);
    let url = this._url + `${this.context.map.project.id}/location/${lng},${lat},${zoom},${pitch},${bearing}/`;



    return url;
  }

  private legendInfo: {
    legend?: any, searchLegend?: any, selections?: any, buffer?: any
  } = {};

  public get hasSearchLegend(): boolean {
    if (!this.legendInfo) return false;
    if (!this.legendInfo.searchLegend) return false;
    return true;
  }

  private _hasResults;
  public get hasResults(): boolean {
    if (!this.legendInfo) return false;
    return this.hasSelections || this.hasUnSelections;
  }

  private _resultsLabel: string = 'Hilighted Features';

  public set resultsLabel(label: string) {
    this._resultsLabel = label;
    this.cdr.detectChanges();

  }
  public get resultsLabel(): string {
    return this._resultsLabel;
  }

  public get hasInputFeature(): boolean {
    return this.legendInfo.searchLegend?.inputFeatures?.legend?.length > 0;
  }

  private _inputFeatureLabel: string = '';
  public set inputFeatureLabel(label: string) {
    this._inputFeatureLabel = label;
    this.cdr.detectChanges();
  }
  public get inputFeatureLabel(): string {
    if (!this.legendInfo?.searchLegend?.inputFeatures) return '';
    if (this._inputFeatureLabel === '') {
      const labelInfo = this.legendInfo.searchLegend.inputFeatures.layer.GetLabelInfo();
      if (labelInfo.labelField === '_sl_override_or_inherit_') {
        this._inputFeatureLabel = labelInfo.labelOverride;
      }
      if (this._inputFeatureLabel === '') {
        this._inputFeatureLabel = this.legendInfo.searchLegend.inputFeatures.layer.name;
      }
    }
    return this._inputFeatureLabel;
  }
  public get inputFeatureSwatch(): string {
    const img = this.legendInfo.searchLegend?.inputFeatures?.legend[0]?.swatch;
    if (!img) return 'javascript:void(0)';
    return img;
  }

  public get hasBuffer(): boolean {
    if (this.legendInfo.buffer?.value === 0) return false;
    if (!this.legendInfo?.searchLegend?.inputBuffer) return false;
    return true;
  }

  private _units = 'meters';
  private _bufferLabel: string = 'Buffer: %radius%';
  public set bufferLabel(label: string) {
    this._bufferLabel = label;
    this.Refresh();
  }
  public get bufferLabel(): string {
    return this._bufferLabel;
  }
  public get safeBufferLabel(): SafeHtml {
    const radius = this.legendInfo.buffer.value;
    const diameter = radius * 2;
    const area = Math.PI * Math.pow(radius, 2);
    const units = this._units;
    let labelStr: string = '' + this._bufferLabel as string;
    labelStr = labelStr.replace('%diameter%', `${diameter.toFixed(4)} ${units}`);
    labelStr = labelStr.replace('%radius%', `${radius.toFixed(4)} ${units}`);
    labelStr = labelStr.replace('%area%', `${area.toFixed(4)} ${units} <sup>2</sup></sup>`);
    return this.sanitizer.bypassSecurityTrustHtml(labelStr);
  }
  public get bufferSwatch(): string {
    const swatch = this.legendInfo?.searchLegend?.inputBuffer?.legend[0]?.swatch;
    if (!swatch) return 'javasript:void(0)';
    return swatch;
  }

  public get hasSelections(): boolean {
    return (!!this.legendInfo?.selections?.selections?.features?.length);
  }

  private _selectionsLabel: string = 'Features of Interest';
  public set selectionsLabel(label: string) {
    this._selectionsLabel = label;
    this.Refresh();
  }
  public get selectionsLabel(): string {
    return this._selectionsLabel;
  }
  public get selectionsSwatch(): string {
    const swatch = this.legendInfo?.searchLegend['sel-results']?.legend[0]?.swatch;
    return !!swatch ? swatch as string : '';
  }

  public get hasUnSelections(): boolean {
    return (!!this.legendInfo?.selections?.selections?.unfeatures?.length);
  }

  private _unselectionsLabel: string = 'Related Features of Interest';
  public set unselectionsLabel(label: string) {
    this._unselectionsLabel = label;
    this.Refresh();
  }
  public get unselectionsLabel(): string {
    return this._unselectionsLabel;
  }
  public get unselectionsSwatch(): string {
    const swatch = this.legendInfo?.searchLegend['unsel-results']?.legend[0]?.swatch;
    return !!swatch ? swatch as string : '';
  }


  @ViewChild('pdfPage') pdfPage: ElementRef<HTMLDivElement>;
  @ViewChild('pageContainer') pageContainer: ElementRef<HTMLDivElement>;
  @ViewChild('previewImg') previewImg: ElementRef<HTMLImageElement>;
  private _buffer: HTMLCanvasElement;
  private context?: SLContext;
  private _capturing: boolean = false;
  private _ready: boolean = false;

  public get generatedBy(): string {
    const date = DateQualifierService.ToString(new Date(), 'date#March 04, 2345');
    const logoImg = '<img class="by-logo" src="/assets/images/SL_logo.png" />';

    const attribution = `<div>Exported  from: <span class="by-title">${this.context?.map?.project?.name}</span></div><div>hosted by ${logoImg}</div>`;
    return attribution;
    // return this.sanitizer.bypassSecurityTrustHtml(attribution);
  }

  public get exportDate(): string {
    return 'Exported: ' + DateQualifierService.ToString(new Date(), 'date#March 04, 2345');
  }

  private previewTimer = new InterruptableTimer(1000);

  constructor(
    private activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private mediaSvc: MediaService,
    private envSvc: EnvService,
    private messager: ModalMessagerService,
    private domNode: ElementRef<HTMLDivElement>,
    private scaleLocSvc: ScaleAndLocationDialogService
  ) {

  }
  _modalElement: HTMLDivElement;
  _dragging?: any;
  ngOnInit() {
    this._ready = true;
    window.requestAnimationFrame(() => {
      this._modalElement = window.document.getElementsByClassName('pdf-output-preview-dialog')[0] as HTMLDivElement;
    })
    PdfExportService.SetUnits();
    this.pdfWidth = (PdfExportService.ScreenUnitPerInch * 11) + 'px';
    this.pdfHeight = (PdfExportService.ScreenUnitPerInch * 8.5) + 'px';
    this.orientation = 'landscape';

    this.mediaSvc.GetOrgMedia(this.context.map.project, (url) => {
      this._orgLogo = url;
      this.Refresh();
      window.requestAnimationFrame(() => {
        this.previewTimer.Start();

      })

    }, 'logo');
    if (this.previewImg) {

      /*this.previewImg.nativeElement.addEventListener('dragstart', (event) => {
        this._dragging = { x: 0, y: 0 };
        this.previewImg.nativeElement.style.top = this._dragging.y + "px";
        this.previewImg.nativeElement.style.left = this._dragging.x + "px";
        event.preventDefault();
        console.log(event);
        return true;
      });
      this.previewImg.nativeElement.addEventListener('mouseup', (event) => {
        this._dragging = undefined;
        event.preventDefault();

        console.log(event);
        return true;
      });
      this.previewImg.nativeElement.addEventListener('mousemove', (event) => {
        if(!this._dragging) return;
        // calculate the new position
        event.preventDefault();

        this._dragging.x += event.movementX;
        this._dragging.y += event.movementY;

        // with each move we also want to update the start X and Y

        // set the element's new position:
        this.previewImg.nativeElement.style.top = this._dragging.y + "px";
        this.previewImg.nativeElement.style.left = this._dragging.x + "px";
        return true;
      });
      */
    }
    this.Refresh();

    setTimeout(() => {
      this.Capture();
    }, 500);

  }
  UpdateSpecial() {
    let included = this.includeLegend;
    included ||= this.includeNotes;
    if (this.useSpecial !== included) {
      this.useSpecial = included;
      this.Capture();
    }
  }
  Capture() {
    PdfExportService.SetUnits();
    this._capturing = true;
    if (!this.context) return 'javascript:void(0)';
    if (!this.context.map.ui) return 'javascript:void(0)';
    if (!this.pdfPage) return 'javascript:void(0)';
    this.pdfPage.nativeElement.style.setProperty('--angle', this.angle);
    this.pdfPage.nativeElement.classList.toggle('capturing', true);
    const canvas = this.context.map.ui.getCanvas() as HTMLCanvasElement;
    const minDim = Math.min(canvas.width, canvas.height);
    const squareDim = minDim;
    const width = PdfExportService.ScreenUnitPerInch * 8.5;
    const height = Math.min(canvas.height, PdfExportService.ScreenUnitPerInch * 7, (PdfExportService.ScreenUnitPerInch * (7 - (this.useSpecial ? 2.5 : 0))));
    let x = ((canvas.width / 2.0) - (width / 2.0));
    let y = ((canvas.height / 2.0) - (height / 2.0));
    //const data = PdfExportService.SubsetCanvas(canvas, x, y, squareDim, squareDim);
    const data = PdfExportService.SubsetCanvas(canvas, x, y, width, height);
    this._imgWidth = width;
    this._imgWidth = height;
    this._image = data;

    this.legendInfo = this.ProcessLegend();
    this.cdr.markForCheck();
    this.cdr.detectChanges();
    this.Refresh();


  }
  SetupResultsLegend() {
    if (!this.legendInfo) {
      this._hasResults = false;
    }
  }
  ProcessLegend(nodes?: Array<any>) {
    if (!(this.context as any).legendView) return;
    const legend: LegendViewComponent = (this.context as any).legendView as LegendViewComponent;

    const legendItems = {};
    const searchLegend = {};
    let selections;
    let buffer;
    if (!nodes) nodes = legend.nodes[0].children as Array<any>;
    nodes.every((value: any) => {
      var info: any = {};
      if (value.layer.layerOn === false) return true;
      if (value.layer.includeInLegend === false) return true;
      const node: any = {
        icon: (value.icon === 'font-icon') ? value.layer.fontIcon : value.layer.icon,
        name: value.name,
        description: value.layer.description,
        layer: value.layer
      }
      if (!!value.component && !!value.component.legend) {
        if (value.component.closed === true) return true;

        const nodeLegend: any[] = [];
        for (const legendEntry of value.component.legend) {
          const legendClass: LegendClassComponent = legendEntry.component as LegendClassComponent;
          if (legendClass.isVis=== false) {
            continue;
          }
          nodeLegend.push({ name: legendClass.item.class_name, swatch: legendClass.GetSwatchURL() });

        }
        node.legend = nodeLegend;
      }
      if (value.id === 'results') {
        selections = value.layer?.selectionData;
        buffer = value.layer?.moment?.bufferSrc;
        for (const virtual of value.children) {
          if (!(virtual as any).component) continue;
          if ((virtual as any).layer.layerOn === false) continue;
          if ((virtual as any).layer.includeInLegend === false) continue;

          const virtualNode: any = {
            icon: (virtual.icon === 'font-icon') ? virtual.layer.fontIcon : virtual.layer.icon,
            name: virtual.name,
            description: virtual.layer.description,
            layer: virtual.layer
          }
          if (!!virtual.component && !!virtual.component?.legend) {
            if (virtual.component.closed === true) return true;
            const virtualLegend: any[] = [];
            for (const legendEntry of virtual.component.legend) {
              const legendClass: LegendClassComponent = legendEntry.component as LegendClassComponent;

              virtualLegend.push({ name: legendClass.item.class_name, swatch: legendClass.GetSwatchURL(), isVis: legendClass.isVis });
            }
            virtualNode.legend = virtualLegend;
          }

          searchLegend[virtual.id] = virtualNode;
        }
        return true;
      }

      if (value.children && value.children.length > 0) {
        const legendInfo = this.ProcessLegend(value.children);
        if (legendInfo.legend) {
          if (Object.keys(legendInfo.legend).length === 0) return true;
          node.children = legendInfo.legend;
          /*for (let key in legendInfo.legend) {
            legend[key] = legendInfo.legend;
          }*/
        }

      }
      legendItems[value.id] = node;
      return true;
    });
    return { legend: legendItems, searchLegend: searchLegend, selections: (selections), buffer: (buffer) };

  }
  ProcessResultsLegend() {

  }
  Export() {
    this.RefreshPreview(() => {
      PdfExportService.ExportBuffer(this.context as AppContext, this._buffer);
    });
  }
  SavePng() {
    this.RefreshPreview(() => {
      this.messager.RequestExport({
        extension: '.png',
        defaultFileName: this.title.replace(' ', '_'),
        mimeType: 'image/png',
        contents: this._buffer.toDataURL()
      }, 'Save image as PNG');
    });
  }
  SaveToClipboard() {
    this.RefreshPreview(() => {
      const blob = this._buffer.toBlob((blob: Blob) => {
        navigator.clipboard.write([
          new ClipboardItem({
            [blob.type]: blob
          })
        ])
      }, 'image/png');
    });
  }
  RefreshPreview(handler?: AnyHandler) {
    this.messager.Progress('Adjusting styles for print', false, 0, 'Generating Image');
    this._capturing = true;
    this.pdfPage.nativeElement.classList.toggle('capturing', true);
    this.Refresh();
    this.messager.Progress('Making image', false, .5, 'Generating Image');
    setTimeout(() => {
      this.GetPreview(handler);
      this.pdfPage.nativeElement.classList.toggle('capturing', true,);
      this.messager.Progress('Restoring styles', false, 1, 'Generating Image');
    }, 10)

  }
  GetPreview(handler?: AnyHandler) {
    if (!this._capturing) return;
    html2canvas(this.pdfPage.nativeElement, {
      width: this.pdfPage.nativeElement.clientWidth,
      height: this.pdfPage.nativeElement.clientHeight,
      scrollX: 0,
      scrollY: 0,
      removeContainer: true
    }).then((canvas: HTMLCanvasElement) => {
      canvas.getContext('2d', { willReadFrequently: true });
      this._buffer = canvas;
      this.pdfPage.nativeElement.classList.toggle('capturing', false);
      this._capturing = false;
      this.Refresh();
      if (!!handler) handler();
    });
  }
  Show(args: any) {
    this.context = args.params as SLContext;
    this.Refresh();
  }
  SwitchOrientation() {
    if (this.orientation === 'landscape') {
      this.orientation = 'portrait';
    } else {
      this.orientation = 'landscape';
    }
    /*const current = this._pdfWidth;
    this._pdfWidth = this._pdfHeight;
    this._pdfHeight = current;*/
    this.Refresh();
  }
  Refresh() {
    if (this._ready === false) return;
    this.cdr.detectChanges();
  }
  Cancel() {
    this.activeModal.close();
  }
  GetMapScale(unit: 'meters' | 'feet' = 'meters'): string {
    if (!this.context?.map?.ui) return '';
    const center = this.context.map.ui.getCenter();
    const zoom = this.context.map.ui.getZoom();
    const metersPerPx = 156543.03392 * Math.cos(center.lat * Math.PI / 180) / Math.pow(2, zoom);
    const pxInch = PdfExportService.ScreenUnitPerInch;
    const metersPerInchish = (pxInch * metersPerPx);
    if (unit === 'meters') {
      return NumberQualifierService.ToString(metersPerInchish, 'comma-dot', 2) + ' m';
    }
    return NumberQualifierService.ToString(metersPerInchish * 3.28084, 'comma-dot', 2) + ' ft';
  }
  ImageMoved(event) {
    console.log(event);
    return true;

  }
  ImageDropped(event) {
    console.log(event);
    return true;
  }
  ConfigScaleBar() {
    this.scaleLocSvc.Show(() => {
      this.Capture();
    });
  }
}


@Component({
  selector: 'app-pdf-output-preview-dialog-entry',
  template: ''
})
export class PDFOutputPreviewDialogEntryComponent implements OnDestroy {
  modalRef: NgbModalRef;
  subscriptionMgr: SubScriptionMgr = new SubScriptionMgr();
  lastTitle: string | null = null;

  constructor(private modalService: NgbModal, private service: PDFOutputPreviewDialogService) {
    this.subscriptionMgr.Subscribe(service.request$, (info: any) => {
      if (this.modalRef?.componentInstance !== undefined) {
        (this.modalRef.componentInstance as PDFOutputPreviewDialogComponent).minimized = false;
        return;
      }
      this.modalRef = this.modalService.open(PDFOutputPreviewDialogComponent, {
        backdrop: 'static',
        windowClass: 'pdf-output-preview-dialog',
        backdropClass: 'hidden'
      });

      (this.modalRef.componentInstance as PDFOutputPreviewDialogComponent).Show(info);
    });
  }

  ngOnDestroy(): void {
    this.subscriptionMgr.CancelSubscriptions();
  }
}
